import { Finder, IFinder } from "../finder/IFinder"
import { INode } from "../types/INode"

export interface IIdx extends INode {

    _id: any;
    parent_id: any; 
    version: number;
    type: string;
    idn?: string;
    _err: any;
    fnd:string;
    del:number;

    link_graflow:string // link do technologii
    lbl_id: any
    indeks_finder: IFinder;

    // przeniesione do lbl START
    nawijanie: string  // *Kierunek Nawijania
    rodzaj_zlecenia: string  // Rodzaj Zlecenia
    technologia_cyfra: string  // Rodzaj Technologii W Druku Cyfrowym
    nr_indeksu: string  // Symbol Etykiety
    nr_indeksu_wzor: string  // Symbol Etykiety Wzorcowej
    nr_klienta_wzor: string  // klient do tworzenia nowej etykiety w ERP
    nr_technologii_wzor: number  // np 4=flekso

    klient_wzor: IFinder;
    jm_idn: string  // Symbol Jednostki Miary
    nazwa_etykiety: string  // Nazwa Etykiety
    numer_indeksu_u_klienta: string  // Numer Indeksu U Klienta
    specyfikacja_klienta: string  // Specyfikacja Klienta
    barcode: string  // Kod Kreskowy Na Etykiecie
    srednica_wewn_gilzy: string  // Średnica Wewnętrzna Gilzy
    srednica_zewn_rolki: string  // Średnica Zewnętrzna Rolki
    ilosc_sztuk: string  // Ilość Sztuk
    pakowanie: string  // *Pakowanie
    uwagi: string  // Uwagi
    uwagi1: string  // Uwagi1
    wspolny_montaz: string  // Wspólny Montaż Z
    ilosc_etykiet_na_wykrojnik: string  // Ilość Etykiet Na Wykrojnik
    nr_indeksu_matka: string  // Etykieta Matka
    nr_wykrojnika: string  // *Nr_Wykrojnika
    // przeniesione do lbl END



    surowiec_1: string  // *Surowiec
    surowiec_2: string  // Surowiec B
    surowiec_3: string  // Surowiec C
    uszlachetnienie_wstega_1: string  // Uszlachetnienie Wstęga 1
    uszlachetnienie_krotnosc_wstega_1: number  // Krotność Użycia Wstęgi 1
    uszlachetnienie_wstega_2: string  // Uszlachetnienie Wstęga 2
    uszlachetnienie_krotnosc_wstega_2: number  // Krotność Użycia Wstęgi 2
    uszlachetnienie_wstega_3: string  // Uszlachetnienie Wstęga 3
    uszlachetnienie_krotnosc_wstega_3: number  // Krotność Użycia Wstęgi 3
    lakierowanie_1: string  // *Lakierowanie
    lakierowanie_typ_1: string  // Typ Pokrycia Lakierem 1
    lakierowanie_2: string  // Lakierowanie B
    lakierowanie_typ_2: string  // Typ Pokrycia Lakierem 2
    ilosc_kolorow_zakl: number  // *Kolory Ilość Zakładana
    rodzaj_farb: string  // *Rodzaj Farb
    ilosc_kolorow_flexo: number  // Ilość Kolorow Ctp
    ilosc_negatywow: number  // Ilość Negatywow
    cyfra_kolory: number  // Ilość Kolorów (Bez Białego) Cyfra Hp
    cyfra_biel_std: number  // Ilość Białego Standard Cyfra Hp
    cyfra_biel_premium: number  // Ilość Białego Premium Cyfra Hp
    sito: number  // Sito
    ilosc_plyt_offsetowych: number  // Ilosc Płyt Offsetowych
    ilosc_innych: string  // Ilość Innych

    
    kolor_1: string  // Kolor 1
    wspolnota_kolorow_1: string  // Wspólnota Kolorów 1
    wersja_we_wspolnocie_kolorow_1: string  // Wersja We Wspólnocie Kol.2
    nr_farby_grafpol_1: string  // Nr Farby Grafpol 1
    kolor_2: string  // Kolor 2
    wspolnota_kolorow_2: string  // Wspólnota Kolorów 2
    wersja_we_wspolnocie_kolorow_2: string  // Wersja We Wspólnocie Kol.2
    nr_farby_grafpol_2: string  // Nr Farby Grafpol 2
    kolor_3: string  // Kolor 3
    wspolnota_kolorow_3: string  // Wspólnota Kolorów 3
    wersja_we_wspolnocie_kolorow_3: string  // Wersja We Wspólnocie Kol.3
    nr_farby_grafpol_3: string  // Nr Farby Grafpol 3
    kolor_4: string  // Kolor 4
    wspolnota_kolorow_4: string  // Wspólnota Kolorów 4
    wersja_we_wspolnocie_kolorow_4: string  // Wersja We Wspólnocie Kol.4
    nr_farby_grafpol_4: string  // Nr Farby Grafpol 4
    kolor_5: string  // Kolor 5
    wspolnota_kolorow_5: string  // Wspólnota Kolorów 5
    wersja_we_wspolnocie_kolorow_5: string  // Wersja We Wspólnocie Kol.5
    nr_farby_grafpol_5: string  // Nr Farby Grafpol 5
    kolor_6: string  // Kolor 6
    wspolnota_kolorow_6: string  // Wspólnota Kolorów 6
    wersja_we_wspolnocie_kolorow_6: string  // Wersja We Wspólnocie Kol.6
    nr_farby_grafpol_6: string  // Nr Farby Grafpol 6
    kolor_7: string  // Kolor 7
    wspolnota_kolorow_7: string  // Wspólnota Kolorów 7
    wersja_we_wspolnocie_kolorow_7: string  // Wersja We Wspólnocie Kol.7
    nr_farby_grafpol_7: string  // Nr Farby Grafpol 7
    kolor_8: string  // Kolor 8
    wspolnota_kolorow_8: string  // Wspólnota Kolorów 8
    wersja_we_wspolnocie_kolorow_8: string  // Wersja We Wspólnocie Kol.8
    nr_farby_grafpol_8: string  // Nr Farby Grafpol 8
    kolor_9: string  // Kolor 9
    wspolnota_kolorow_9: string  // Wspólnota Kolorów 9
    wersja_we_wspolnocie_kolorow_9: string  // Wersja We Wspólnocie Kol.9
    nr_farby_grafpol_9: string  // Nr Farby Grafpol 9
    kolor_10: string  // Kolor 10
    wspolnota_kolorow_10: string  // Wspólnota Kolorów 10
    wersja_we_wspolnocie_kolorow_10: string  // Wersja We Wspólnocie Kol.10
    nr_farby_grafpol_10: string  // Nr Farby Grafpol 10
    kolor_11: string  // Kolor 11
    wspolnota_kolorow_11: string  // Wspólnota Kolorów 11
    wersja_we_wspolnocie_kolorow_11: string  // Wersja We Wspólnocie Kol.11
    nr_farby_grafpol_11: string  // Nr Farby Grafpol 11
    kolor_12: string  // Kolor 12
    wspolnota_kolorow_12: string  // Wspólnota Kolorów 12
    wersja_we_wspolnocie_kolorow_12: string  // Wersja We Wspólnocie Kol.12
    nr_farby_grafpol_12: string  // Nr Farby Grafpol 12
    kolor_13: string  // Kolor 13
    wspolnota_kolorow_13: string  // Wspólnota Kolorów 13
    wersja_we_wspolnocie_kolorow_13: string  // Wersja We Wspólnocie Kol.13
    nr_farby_grafpol_13: string  // Nr Farby Grafpol 13
    kolor_14: string  // Kolor 14
    wspolnota_kolorow_14: string  // Wspólnota Kolorów 14
    wersja_we_wspolnocie_kolorow_14: string  // Wersja We Wspólnocie Kol.14
    nr_farby_grafpol_14: string  // Nr Farby Grafpol 14
    kolor_15: string  // Kolor 15
    wspolnota_kolorow_15: string  // Wspólnota Kolorów 15
    wersja_we_wspolnocie_kolorow_15: string  // Wersja We Wspólnocie Kol.15
    nr_farby_grafpol_15: string  // Nr Farby Grafpol 15
    kolor_16: string  // Kolor 16
    wspolnota_kolorow_16: string  // Wspólnota Kolorów 16
    wersja_we_wspolnocie_kolorow_16: string  // Wersja We Wspólnocie Kol.16
    nr_farby_grafpol_16: string  // Nr Farby Grafpol 16
    kolor_17: string  // Kolor 17
    wspolnota_kolorow_17: string  // Wspólnota Kolorów 17
    wersja_we_wspolnocie_kolorow_17: string  // Wersja We Wspólnocie Kol.17
    nr_farby_grafpol_17: string  // Nr Farby Grafpol 17
    kolor_18: string  // Kolor 18
    wspolnota_kolorow_18: string  // Wspólnota Kolorów 18
    wersja_we_wspolnocie_kolorow_18: string  // Wersja We Wspólnocie Kol.18
    nr_farby_grafpol_18: string  // Nr Farby Grafpol 18
    kolor_19: string  // Kolor 19
    wspolnota_kolorow_19: string  // Wspólnota Kolorów 19
    wersja_we_wspolnocie_kolorow_19: string  // Wersja We Wspólnocie Kol.19
    nr_farby_grafpol_19: string  // Nr Farby Grafpol 19
    kolor_20: string  // Kolor 20
    wspolnota_kolorow_20: string  // Wspólnota Kolorów 20
    wersja_we_wspolnocie_kolorow_20: string  // Wersja We Wspólnocie Kol.20
    nr_farby_grafpol_20: string  // Nr Farby Grafpol 20
    data_oddania_klisz_na_produkcje: string  // Data Oddania Klisz Na Produkcję
    ilosc_kolorow_rzeczyw: number  // Kolory Ilość Rzeczywista
    data_otrzymania_w_studiu: string  // Otrzymano W Studiu
    kto_projektowal: string  // Kto Projektował
    kto_przygotowal_do_druku: string  // Przyg. Do Druku
    wyroznik: string  // Wyróżnik
    nr_zlocenie_na_goraco_online: string  // Numer Złocenia Na Gorąco Online
    grupa_maszyn: string  // *Grupa Maszyn
    specjalna_szerokosc_wstegi_1: number  // Specjalna Szerokość Wstęgi 1
    specjalna_szerokosc_wstegi_2: number  // Specjalna Szerokość Wstęgi 2
    specjalna_szerokosc_wstegi_3: number  // Specjalna Szerokość Wstęgi 3
    poddruk_na_kleju_lub_silikonie: string  // Poddruk Na Kleju Lub Silikonie
    formatkowanie: string  // Formatkowanie
    sekwencja_kolorow: string  // Sekwencja Kolorów
    czas_przezbrojenia_min: number  // Czas Przezbrojenia 1 W Minutach
    czas_druku_2000m_min: number  // Czas Druku 1 Dla 2000M W Minutach
    technologia: string  // Technologia
    zasoby1: string  // Zasoby1
    zasoby2: string  // Zasoby2
    czy_zlikwidowane_polimery: string  // Czy Zlikwidowane Polimery
    status_wzoru_etykiety: string  // Status Wzoru Etykiety
    kalk_id: number  // Nr Kalkulacji
    etykieta_flekso: string  // Dotychcz. Etykieta Flexo
    uwagi_przy_etykiecie: string  // Uwagi Przy Etykiecie
    prj_id:string;
}


export class Idx implements IIdx {

    _id: any;
    parent_id: any;
    version: number=1;
    type: string='idx';
    idn?: string="";
    _err: any={};
    fnd:string=""
    del:number=0

    link_graflow:string=""
    lbl_id:any

    indeks_finder: IFinder=new Finder();

    nr_indeksu: string = "" //  Symbol Etykiety
    nr_indeksu_wzor: string = "" //  Symbol Etykiety Wzorcowej
    nr_klienta_wzor: string = ""
    nr_technologii_wzor: number = 4
    klient_wzor: IFinder = new Finder();

    jm_idn: string = "" //  Symbol Jednostki Miary
    nazwa_etykiety: string = "" //  Nazwa Etykiety
    surowiec_1: string = "" //  *Surowiec
    surowiec_2: string = "" //  Surowiec B
    surowiec_3: string = "" //  Surowiec C
    uszlachetnienie_wstega_1: string = "" //  Uszlachetnienie Wstęga 1
    uszlachetnienie_krotnosc_wstega_1: number = 0 //  Krotność Użycia Wstęgi 1
    uszlachetnienie_wstega_2: string = "" //  Uszlachetnienie Wstęga 2
    uszlachetnienie_krotnosc_wstega_2: number = 0 //  Krotność Użycia Wstęgi 2
    uszlachetnienie_wstega_3: string = "" //  Uszlachetnienie Wstęga 3
    uszlachetnienie_krotnosc_wstega_3: number = 0 //  Krotność Użycia Wstęgi 3
    nr_indeksu_matka: string = "" //  Etykieta Matka
    nr_wykrojnika: string = "" //  *Nr_Wykrojnika
    lakierowanie_1: string = "" //  *Lakierowanie
    lakierowanie_typ_1: string = "" //  Typ Pokrycia Lakierem 1
    lakierowanie_2: string = "" //  Lakierowanie B
    lakierowanie_typ_2: string = "" //  Typ Pokrycia Lakierem 2
    nawijanie: string = "" //  *Kierunek Nawijania
    rodzaj_zlecenia: string = "" //  Rodzaj Zlecenia
    technologia_cyfra: string = "" //  Rodzaj Technologii W Druku Cyfrowym
    ilosc_kolorow_zakl: number = 0 //  *Kolory Ilość Zakładana
    rodzaj_farb: string = "" //  *Rodzaj Farb
    ilosc_kolorow_flexo: number = 0 //  Ilość Kolorow Ctp
    ilosc_negatywow: number = 0 //  Ilość Negatywow
    cyfra_kolory: number = 0 //  Ilość Kolorów (Bez Białego) Cyfra Hp
    cyfra_biel_std: number = 0 //  Ilość Białego Standard Cyfra Hp
    cyfra_biel_premium: number = 0 //  Ilość Białego Premium Cyfra Hp
    sito: number = 0 //  Sito
    ilosc_plyt_offsetowych: number = 0 //  Ilosc Płyt Offsetowych
    ilosc_innych: string = "" //  Ilość Innych
    numer_indeksu_u_klienta: string = "" //  Numer Indeksu U Klienta
    specyfikacja_klienta: string = "" //  Specyfikacja Klienta
    barcode: string = "" //  Kod Kreskowy Na Etykiecie
    srednica_wewn_gilzy: string = "" //  Średnica Wewnętrzna Gilzy
    srednica_zewn_rolki: string = "" //  Średnica Zewnętrzna Rolki
    ilosc_sztuk: string = "" //  Ilość Sztuk
    pakowanie: string = "" //  *Pakowanie
    uwagi: string = "" //  Uwagi
    uwagi1: string = "" //  Uwagi1
    wspolny_montaz: string = "" //  Wspólny Montaż Z
    ilosc_etykiet_na_wykrojnik: string = "" //  Ilość Etykiet Na Wykrojnik
    kolor_1: string = "" //  Kolor 1
    wspolnota_kolorow_1: string = "" //  Wspólnota Kolorów 1
    wersja_we_wspolnocie_kolorow_1: string = "" //  Wersja We Wspólnocie Kol.1
    nr_farby_grafpol_1: string = "" //  Nr Farby Grafpol 1
    kolor_2: string = "" //  Kolor 2
    wspolnota_kolorow_2: string = "" //  Wspólnota Kolorów 2
    wersja_we_wspolnocie_kolorow_2: string = "" //  Wersja We Wspólnocie Kol.2
    nr_farby_grafpol_2: string = "" //  Nr Farby Grafpol 2
    kolor_3: string = "" //  Kolor 3
    wspolnota_kolorow_3: string = "" //  Wspólnota Kolorów 3
    wersja_we_wspolnocie_kolorow_3: string = "" //  Wersja We Wspólnocie Kol.3
    nr_farby_grafpol_3: string = "" //  Nr Farby Grafpol 3
    kolor_4: string = "" //  Kolor 4
    wspolnota_kolorow_4: string = "" //  Wspólnota Kolorów 4
    wersja_we_wspolnocie_kolorow_4: string = "" //  Wersja We Wspólnocie Kol.4
    nr_farby_grafpol_4: string = "" //  Nr Farby Grafpol 4
    kolor_5: string = "" //  Kolor 5
    wspolnota_kolorow_5: string = "" //  Wspólnota Kolorów 5
    wersja_we_wspolnocie_kolorow_5: string = "" //  Wersja We Wspólnocie Kol.5
    nr_farby_grafpol_5: string = "" //  Nr Farby Grafpol 5
    kolor_6: string = "" //  Kolor 6
    wspolnota_kolorow_6: string = "" //  Wspólnota Kolorów 6
    wersja_we_wspolnocie_kolorow_6: string = "" //  Wersja We Wspólnocie Kol.6
    nr_farby_grafpol_6: string = "" //  Nr Farby Grafpol 6
    kolor_7: string = "" //  Kolor 7
    wspolnota_kolorow_7: string = "" //  Wspólnota Kolorów 7
    wersja_we_wspolnocie_kolorow_7: string = "" //  Wersja We Wspólnocie Kol.7
    nr_farby_grafpol_7: string = "" //  Nr Farby Grafpol 7
    kolor_8: string = "" //  Kolor 8
    wspolnota_kolorow_8: string = "" //  Wspólnota Kolorów 8
    wersja_we_wspolnocie_kolorow_8: string = "" //  Wersja We Wspólnocie Kol.8
    nr_farby_grafpol_8: string = "" //  Nr Farby Grafpol 8
    kolor_9: string = "" //  Kolor 9
    wspolnota_kolorow_9: string = "" //  Wspólnota Kolorów 9
    wersja_we_wspolnocie_kolorow_9: string = "" //  Wersja We Wspólnocie Kol.9
    nr_farby_grafpol_9: string = "" //  Nr Farby Grafpol 9
    kolor_10: string = "" //  Kolor 10
    wspolnota_kolorow_10: string = "" //  Wspólnota Kolorów 10
    wersja_we_wspolnocie_kolorow_10: string = "" //  Wersja We Wspólnocie Kol.10
    nr_farby_grafpol_10: string = "" //  Nr Farby Grafpol 10
    kolor_11: string = "" //  Kolor 11
    wspolnota_kolorow_11: string = "" //  Wspólnota Kolorów 11
    wersja_we_wspolnocie_kolorow_11: string = "" //  Wersja We Wspólnocie Kol.11
    nr_farby_grafpol_11: string = "" //  Nr Farby Grafpol 11
    kolor_12: string = "" //  Kolor 12
    wspolnota_kolorow_12: string = "" //  Wspólnota Kolorów 12
    wersja_we_wspolnocie_kolorow_12: string = "" //  Wersja We Wspólnocie Kol.12
    nr_farby_grafpol_12: string = "" //  Nr Farby Grafpol 12
    kolor_13: string = "" //  Kolor 13
    wspolnota_kolorow_13: string = "" //  Wspólnota Kolorów 13
    wersja_we_wspolnocie_kolorow_13: string = "" //  Wersja We Wspólnocie Kol.13
    nr_farby_grafpol_13: string = "" //  Nr Farby Grafpol 13
    kolor_14: string = "" //  Kolor 14
    wspolnota_kolorow_14: string = "" //  Wspólnota Kolorów 14
    wersja_we_wspolnocie_kolorow_14: string = "" //  Wersja We Wspólnocie Kol.14
    nr_farby_grafpol_14: string = "" //  Nr Farby Grafpol 14
    kolor_15: string = "" //  Kolor 15
    wspolnota_kolorow_15: string = "" //  Wspólnota Kolorów 15
    wersja_we_wspolnocie_kolorow_15: string = "" //  Wersja We Wspólnocie Kol.15
    nr_farby_grafpol_15: string = "" //  Nr Farby Grafpol 15
    kolor_16: string = "" //  Kolor 16
    wspolnota_kolorow_16: string = "" //  Wspólnota Kolorów 16
    wersja_we_wspolnocie_kolorow_16: string = "" //  Wersja We Wspólnocie Kol.16
    nr_farby_grafpol_16: string = "" //  Nr Farby Grafpol 16
    kolor_17: string = "" //  Kolor 17
    wspolnota_kolorow_17: string = "" //  Wspólnota Kolorów 17
    wersja_we_wspolnocie_kolorow_17: string = "" //  Wersja We Wspólnocie Kol.17
    nr_farby_grafpol_17: string = "" //  Nr Farby Grafpol 17
    kolor_18: string = "" //  Kolor 18
    wspolnota_kolorow_18: string = "" //  Wspólnota Kolorów 18
    wersja_we_wspolnocie_kolorow_18: string = "" //  Wersja We Wspólnocie Kol.18
    nr_farby_grafpol_18: string = "" //  Nr Farby Grafpol 18
    kolor_19: string = "" //  Kolor 19
    wspolnota_kolorow_19: string = "" //  Wspólnota Kolorów 19
    wersja_we_wspolnocie_kolorow_19: string = "" //  Wersja We Wspólnocie Kol.19
    nr_farby_grafpol_19: string = "" //  Nr Farby Grafpol 19
    kolor_20: string = "" //  Kolor 20
    wspolnota_kolorow_20: string = "" //  Wspólnota Kolorów 20
    wersja_we_wspolnocie_kolorow_20: string = "" //  Wersja We Wspólnocie Kol.20
    nr_farby_grafpol_20: string = "" //  Nr Farby Grafpol 20
    data_oddania_klisz_na_produkcje: string = "" //  Data Oddania Klisz Na Produkcję
    ilosc_kolorow_rzeczyw: number = 0 //  Kolory Ilość Rzeczywista
    data_otrzymania_w_studiu: string = "" //  Otrzymano W Studiu
    kto_projektowal: string = "" //  Kto Projektował
    kto_przygotowal_do_druku: string = "" //  Przyg. Do Druku
    wyroznik: string = "" //  Wyróżnik
    nr_zlocenie_na_goraco_online: string = "" //  Numer Złocenia Na Gorąco Online
    grupa_maszyn: string = "" //  *Grupa Maszyn
    specjalna_szerokosc_wstegi_1: number = 0 //  Specjalna Szerokość Wstęgi 1
    specjalna_szerokosc_wstegi_2: number = 0 //  Specjalna Szerokość Wstęgi 2
    specjalna_szerokosc_wstegi_3: number = 0 //  Specjalna Szerokość Wstęgi 3
    poddruk_na_kleju_lub_silikonie: string = "" //  Poddruk Na Kleju Lub Silikonie
    formatkowanie: string = "" //  Formatkowanie
    sekwencja_kolorow: string = "" //  Sekwencja Kolorów
    czas_przezbrojenia_min: number = 0 //  Czas Przezbrojenia 1 W Minutach
    czas_druku_2000m_min: number = 0 //  Czas Druku 1 Dla 2000M W Minutach
    technologia: string = "" //  Technologia
    zasoby1: string = "" //  Zasoby1
    zasoby2: string = "" //  Zasoby2
    czy_zlikwidowane_polimery: string = "" //  Czy Zlikwidowane Polimery
    status_wzoru_etykiety: string = "" //  Status Wzoru Etykiety
    kalk_id: number = 0 //  Nr Kalkulacji
    etykieta_flekso: string = "" //  Dotychcz. Etykieta Flexo
    uwagi_przy_etykiecie: string = "" //  Uwagi Przy Etykiecie
    prj_id=""



    public init_from_sql_row(r:any) {
        
        this.nr_indeksu = r['etykieta']  // Symbol Etykiety
        this.nr_indeksu_wzor = r['wzor_idm']  // Symbol Etykiety Wzorcowej
        this.jm_idn = r['jm']  // Symbol Jednostki Miary
        this.nazwa_etykiety = r['nazwa']  // Nazwa Etykiety

        this.surowiec_1 = r['01_surowiec']  // *Surowiec
        this.surowiec_2 = r['01b_surowiec']  // Surowiec B
        this.surowiec_3 = r['01c_surowiec']  // Surowiec C
        this.uszlachetnienie_wstega_1 = r['01d_zloc_lam1']  // Uszlachetnienie Wstęga 1
        this.uszlachetnienie_krotnosc_wstega_1 = r['01d_zloc_lam1a']  // Krotność Użycia Wstęgi 1
        this.uszlachetnienie_wstega_2 = r['01d_zloc_lam2']  // Uszlachetnienie Wstęga 2
        this.uszlachetnienie_krotnosc_wstega_2 = r['01d_zloc_lam2a']  // Krotność Użycia Wstęgi 2
        this.uszlachetnienie_wstega_3 = r['01d_zloc_lam3']  // Uszlachetnienie Wstęga 3
        this.uszlachetnienie_krotnosc_wstega_3 = r['01d_zloc_lam3a']  // Krotność Użycia Wstęgi 3
        this.nr_indeksu_matka = r['01e_et_matka']  // Etykieta Matka
        this.nr_wykrojnika = r['02_nr_wykrojnik']  // *Nr_Wykrojnika
        this.lakierowanie_1 = r['03_lakierowanie']  // *Lakierowanie
        this.lakierowanie_typ_1 = r['03a_typ_lakieru']  // Typ Pokrycia Lakierem 1
        this.lakierowanie_2 = r['03b_lakierow_b']  // Lakierowanie B
        this.lakierowanie_typ_2 = r['03c_typ_lakieru']  // Typ Pokrycia Lakierem 2
        this.nawijanie = r['04_kierunek_naw']  // *Kierunek Nawijania
        this.rodzaj_zlecenia = r['05_rodzaj_zlece']  // Rodzaj Zlecenia
        this.technologia_cyfra = r['05a_rodz_zlec_c']  // Rodzaj Technologii W Druku Cyfrowym
        this.ilosc_kolorow_zakl = r['06_kolor_il_zak']  // *Kolory Ilość Zakładana
        this.rodzaj_farb = r['07_rodzaj_farb']  // *Rodzaj Farb
        this.ilosc_kolorow_flexo = r['08_ctp']  // Ilość Kolorow Ctp
        this.ilosc_negatywow = r['08a_negat']  // Ilość Negatywow
        this.cyfra_kolory = r['08b_cyf_kolory']  // Ilość Kolorów (Bez Białego) Cyfra Hp
        this.cyfra_biel_std = r['08c_cyf_biel_st']  // Ilość Białego Standard Cyfra Hp
        this.cyfra_biel_premium = r['08d_cyf_biel_pr']  // Ilość Białego Premium Cyfra Hp
        this.sito = r['09_sito']  // Sito
        this.ilosc_plyt_offsetowych = r['09a_pl_offset']  // Ilosc Płyt Offsetowych
        this.ilosc_innych = r['09b_inne']  // Ilość Innych
        this.numer_indeksu_u_klienta = r['10_ind__klienta']  // Numer Indeksu U Klienta
        this.specyfikacja_klienta = r['10a_spec_klient']  // Specyfikacja Klienta
        this.barcode = r['10b_barcode']  // Kod Kreskowy Na Etykiecie
        this.srednica_wewn_gilzy = r['11_sr_wew_gilzy']  // Średnica Wewnętrzna Gilzy
        this.srednica_zewn_rolki = r['12_sr_zew_rolki']  // Średnica Zewnętrzna Rolki
        this.ilosc_sztuk = r['13_ilosc_szt']  // Ilość Sztuk
        this.pakowanie = r['14*pakowanie']  // *Pakowanie
        this.uwagi = r['15_uwagi']  // Uwagi
        this.uwagi1 = r['15a_uwagi']  // Uwagi1
        this.wspolny_montaz = r['15b_wsp_mont']  // Wspólny Montaż Z
        this.ilosc_etykiet_na_wykrojnik = r['16_il_etyk_wykr']  // Ilość Etykiet Na Wykrojnik
        this.kolor_1 = r['17_kolor_1']  // Kolor 1
        this.wspolnota_kolorow_1 = r['17a_wsp_kol_1']  // Wspólnota Kolorów 1
        this.wersja_we_wspolnocie_kolorow_1 = r['17aa_wer_k1']  // Wersja We Wspólnocie Kol.1
        this.nr_farby_grafpol_1 = r['17b_nr_farby1']  // Nr Farby Grafpol 1
        this.kolor_2 = r['18_kolor_2']  // Kolor 2
        this.wspolnota_kolorow_2 = r['18a_wsp_kol__2']  // Wspólnota Kolorów 2
        this.wersja_we_wspolnocie_kolorow_2 = r['18aa_wer_k2']  // Wersja We Wspólnocie Kol.2
        this.nr_farby_grafpol_2 = r['18b_nr_farby2']  // Nr Farby Grafpol 2
        this.kolor_3 = r['19_kolor_3']  // Kolor 3
        this.wspolnota_kolorow_3 = r['19a_wsp_kol__3']  // Wspólnota Kolorów 3
        this.wersja_we_wspolnocie_kolorow_3 = r['19aa_wer_k3']  // Wersja We Wspólnocie Kol.3
        this.nr_farby_grafpol_3 = r['19b_nr_farby3']  // Nr Farby Grafpol 3
        this.kolor_4 = r['20_kolor_4']  // Kolor 4
        this.wspolnota_kolorow_4 = r['20a_wsp_kol__4']  // Wspólnota Kolorów 4
        this.wersja_we_wspolnocie_kolorow_4 = r['20aa_wer_k4']  // Wersja We Wspólnocie Kol.4
        this.nr_farby_grafpol_4 = r['20b_nr_farby4']  // Nr Farby Grafpol 4
        this.kolor_5 = r['21_kolor_5']  // Kolor 5
        this.wspolnota_kolorow_5 = r['21a_wsp_kol__5']  // Wspólnota Kolorów 5
        this.wersja_we_wspolnocie_kolorow_5 = r['21aa_wer_k5']  // Wersja We Wspólnocie Kol.5
        this.nr_farby_grafpol_5 = r['21b_nr_farby5']  // Nr Farby Grafpol 5
        this.kolor_6 = r['22_kolor_6']  // Kolor 6
        this.wspolnota_kolorow_6 = r['22a_wsp_kol_6']  // Wspólnota Kolorów 6
        this.wersja_we_wspolnocie_kolorow_6 = r['22aa_wer_k6']  // Wersja We Wspólnocie Kol.6
        this.nr_farby_grafpol_6 = r['22b_nr_farby6']  // Nr Farby Grafpol 6
        this.kolor_7 = r['23_kolor_7']  // Kolor 7
        this.wspolnota_kolorow_7 = r['23a_wsp_kol__7']  // Wspólnota Kolorów 7
        this.wersja_we_wspolnocie_kolorow_7 = r['23aa_wer_k7']  // Wersja We Wspólnocie Kol.7
        this.nr_farby_grafpol_7 = r['23b_nr_farby7']  // Nr Farby Grafpol 7
        this.kolor_8 = r['24_kolor_8']  // Kolor 8
        this.wspolnota_kolorow_8 = r['24a_wsp_kol__8']  // Wspólnota Kolorów 8
        this.wersja_we_wspolnocie_kolorow_8 = r['24aa_wer_k8']  // Wersja We Wspólnocie Kol.8
        this.nr_farby_grafpol_8 = r['24b_nr_farby8']  // Nr Farby Grafpol 8
        this.kolor_9 = r['25_kolor_9']  // Kolor 9
        this.wspolnota_kolorow_9 = r['25a_wsp_kol__9']  // Wspólnota Kolorów 9
        this.wersja_we_wspolnocie_kolorow_9 = r['25aa_wer_k9']  // Wersja We Wspólnocie Kol.9
        this.nr_farby_grafpol_9 = r['25b_nr_farby9']  // Nr Farby Grafpol 9
        this.kolor_10 = r['26_kolor_10']  // Kolor 10
        this.wspolnota_kolorow_10 = r['26a_wsp_kol__10']  // Wspólnota Kolorów 10
        this.wersja_we_wspolnocie_kolorow_10 = r['26aa_wer_k10']  // Wersja We Wspólnocie Kol.10
        this.nr_farby_grafpol_10 = r['26b_nr_farby10']  // Nr Farby Grafpol 10
        this.kolor_11 = r['27_kolor_11']  // Kolor 11
        this.wspolnota_kolorow_11 = r['27a_wsp_kol__11']  // Wspólnota Kolorów 11
        this.wersja_we_wspolnocie_kolorow_11 = r['27aa_wer_k11']  // Wersja We Wspólnocie Kol.11
        this.nr_farby_grafpol_11 = r['27b_nr_farby11']  // Nr Farby Grafpol 11
        this.kolor_12 = r['28_kolor_12']  // Kolor 12
        this.wspolnota_kolorow_12 = r['28a_wsp_kol__12']  // Wspólnota Kolorów 12
        this.wersja_we_wspolnocie_kolorow_12 = r['28aa_wer_k12']  // Wersja We Wspólnocie Kol.12
        this.nr_farby_grafpol_12 = r['28b_nr_farby12']  // Nr Farby Grafpol 12
        this.kolor_13 = r['29_kolor_13']  // Kolor 13
        this.wspolnota_kolorow_13 = r['29a_wsp_kol__13']  // Wspólnota Kolorów 13
        this.wersja_we_wspolnocie_kolorow_13 = r['29aa_wer_k13']  // Wersja We Wspólnocie Kol.13
        this.nr_farby_grafpol_13 = r['29b_nr_farby13']  // Nr Farby Grafpol 13
        this.kolor_14 = r['30_kolor_14']  // Kolor 14
        this.wspolnota_kolorow_14 = r['30a_wsp_kol__14']  // Wspólnota Kolorów 14
        this.wersja_we_wspolnocie_kolorow_14 = r['30aa_wer_k14']  // Wersja We Wspólnocie Kol.14
        this.nr_farby_grafpol_14 = r['30b_nr_farby14']  // Nr Farby Grafpol 14
        this.kolor_15 = r['31_kolor_15']  // Kolor 15
        this.wspolnota_kolorow_15 = r['31a_wsp_kol__15']  // Wspólnota Kolorów 15
        this.wersja_we_wspolnocie_kolorow_15 = r['31aa_wer_k15']  // Wersja We Wspólnocie Kol.15
        this.nr_farby_grafpol_15 = r['31b_nr_farby15']  // Nr Farby Grafpol 15
        this.kolor_16 = r['32_kolor_16']  // Kolor 16
        this.wspolnota_kolorow_16 = r['32a_wsp_kol__16']  // Wspólnota Kolorów 16
        this.wersja_we_wspolnocie_kolorow_16 = r['32aa_wer_k16']  // Wersja We Wspólnocie Kol.16
        this.nr_farby_grafpol_16 = r['32b_nr_farby16']  // Nr Farby Grafpol 16
        this.kolor_17 = r['33_kolor_17']  // Kolor 17
        this.wspolnota_kolorow_17 = r['33a_wsp_kol__17']  // Wspólnota Kolorów 17
        this.wersja_we_wspolnocie_kolorow_17 = r['33aa_wer_k17']  // Wersja We Wspólnocie Kol.17
        this.nr_farby_grafpol_17 = r['33b_nr_farby17']  // Nr Farby Grafpol 17
        this.kolor_18 = r['34_kolor_18']  // Kolor 18
        this.wspolnota_kolorow_18 = r['34a_wsp_kol__18']  // Wspólnota Kolorów 18
        this.wersja_we_wspolnocie_kolorow_18 = r['34aa_wer_k18']  // Wersja We Wspólnocie Kol.18
        this.nr_farby_grafpol_18 = r['34b_nr_farby18']  // Nr Farby Grafpol 18
        this.kolor_19 = r['35_kolor_19']  // Kolor 19
        this.wspolnota_kolorow_19 = r['35a_wsp_kol__19']  // Wspólnota Kolorów 19
        this.wersja_we_wspolnocie_kolorow_19 = r['35aa_wer_k19']  // Wersja We Wspólnocie Kol.19
        this.nr_farby_grafpol_19 = r['35b_nr_farby19']  // Nr Farby Grafpol 19
        this.kolor_20 = r['36_kolor_20']  // Kolor 20
        this.wspolnota_kolorow_20 = r['36a_wsp_kol_20']  // Wspólnota Kolorów 20
        this.wersja_we_wspolnocie_kolorow_20 = r['36aa_wer_k20']  // Wersja We Wspólnocie Kol.20
        this.nr_farby_grafpol_20 = r['36b_nr_farby20']  // Nr Farby Grafpol 20
        this.data_oddania_klisz_na_produkcje = r['37_oddano_klisz']  // Data Oddania Klisz Na Produkcję
        this.ilosc_kolorow_rzeczyw = r['37a_kolor_il_rz']  // Kolory Ilość Rzeczywista
        this.data_otrzymania_w_studiu = r['38_otrzym_w_stu']  // Otrzymano W Studiu
        this.kto_projektowal = r['39_kto_projekt']  // Kto Projektował
        this.kto_przygotowal_do_druku = r['40_przyg_do_dru']  // Przyg. Do Druku
        this.wyroznik = r['41_wyroznik']  // Wyróżnik
        this.nr_zlocenie_na_goraco_online = r['42_nr_zlocenia']  // Numer Złocenia Na Gorąco Online
        this.grupa_maszyn = r['43_grupa_maszyn']  // *Grupa Maszyn
        this.specjalna_szerokosc_wstegi_1 = r['44_spec_szer_ws']  // Specjalna Szerokość Wstęgi 1
        this.specjalna_szerokosc_wstegi_2 = r['44a_spec_szer_2']  // Specjalna Szerokość Wstęgi 2
        this.specjalna_szerokosc_wstegi_3 = r['44b_spec_szer_3']  // Specjalna Szerokość Wstęgi 3
        this.poddruk_na_kleju_lub_silikonie = r['45_poddruk']  // Poddruk Na Kleju Lub Silikonie
        this.formatkowanie = r['46_formatkowan']  // Formatkowanie
        this.sekwencja_kolorow = r['47_sekw_kolorow']  // Sekwencja Kolorów
        this.czas_przezbrojenia_min = r['48_cz_przezbr1']  // Czas Przezbrojenia 1 W Minutach
        this.czas_druku_2000m_min = r['49_czas_druku1']  // Czas Druku 1 Dla 2000M W Minutach
        this.technologia = r['50_technologia']  // Technologia
        this.zasoby1 = r['51_zasoby1']  // Zasoby1
        this.zasoby2 = r['52_zasoby2']  // Zasoby2
        this.czy_zlikwidowane_polimery = r['53_likwid_polim']  // Czy Zlikwidowane Polimery
        this.status_wzoru_etykiety = r['54_wzor_etykiet']  // Status Wzoru Etykiety
        this.kalk_id = r['55_kalkulacja']  // Nr Kalkulacji
        this.etykieta_flekso = r['56_etyk_flexo']  // Dotychcz. Etykieta Flexo
        this.uwagi_przy_etykiecie = r['uwagi']  // Uwagi Przy Etykiecie

    }


}